import { apiClient } from "@/api/client";

export async function uploadFile(file: File, directory?: string) {
  const formData = new FormData();
  formData.append("file", file);

  return await apiClient.post<{ data: { url: string } }>(
    `/api/v1/upload${directory ? `?directory=${directory}` : ""}`,
    {
      body: formData,
    },
  );
}
